import { FSMCommonTransitions, Events } from '../../constants'
import { get, has } from 'lodash'
import { StatesConfigType } from '../../config'

const {
  AUTH_BANK_ID,
  POLICIES_LIST,
  POLICIES_PAYMENT_ERROR,
  POLICIES,
  POLICY_REVIEW,
  POLICY_CHANGE,
  POLICY_VERIFY,
  POLICY_DONE,
  POLICY_MILEAGE,
  MY_PAGES,
  LANDING_PAGE,
  LANDING_PAGE_ABOUT,
  ERROR,
  LANDING_PAGE_QUESTIONS_AND_ANSWERS,
  AUTH,
} = FSMCommonTransitions

export default (FLOW_MACHINE_ID: string): StatesConfigType => ({
  [POLICIES]: {
    initial: POLICIES_LIST,
    states: {
      [POLICIES_LIST]: {
        on: {
          [Events.BACK]: `#${FLOW_MACHINE_ID}.${MY_PAGES}`,
          [Events.NEXT]: POLICY_REVIEW,
          [Events.MILEAGE]: POLICY_MILEAGE,
          [Events.NO_DATA]: `#${FLOW_MACHINE_ID}.${AUTH_BANK_ID}`,
          [Events.MY_PAGES]: `#${FLOW_MACHINE_ID}.${MY_PAGES}`,
          [Events.PAYMENT_SUCCESS]: POLICIES_LIST,
          [Events.PAYMENT_FAILURE]: POLICIES_PAYMENT_ERROR,
          [Events.PAYMENT_ERROR]: POLICIES_PAYMENT_ERROR,
          [Events.PAYMENT_CANCEL]: POLICIES_LIST,
        },
      },
      [POLICY_REVIEW]: {
        on: {
          [Events.BACK]: POLICIES_LIST,
          [Events.CHANGE]: POLICY_CHANGE,
          [Events.NO_DATA]: `#${FLOW_MACHINE_ID}.${AUTH_BANK_ID}`,
          [Events.LANDING_PAGE]: {
            target: `#${FLOW_MACHINE_ID}.${LANDING_PAGE}`,
            actions: 'setBackPath',
          },
        },
      },
      [POLICY_VERIFY]: {
        on: {
          [Events.BACK]: POLICY_CHANGE,
          [Events.NEXT]: POLICY_DONE,
          [Events.LANDING_PAGE]: {
            target: `#${FLOW_MACHINE_ID}.${LANDING_PAGE}`,
            actions: 'setBackPath',
          },
        },
      },
      [POLICY_CHANGE]: {
        on: {
          [Events.BACK]: POLICY_REVIEW,
          [Events.NEXT]: POLICY_VERIFY,
          [Events.LANDING_PAGE]: {
            target: `#${FLOW_MACHINE_ID}.${LANDING_PAGE}`,
            actions: 'setBackPath',
          },
        },
      },
      [POLICY_DONE]: {
        on: {
          [Events.BACK]: `#${FLOW_MACHINE_ID}.${POLICIES}`,
          [Events.NEXT]: `#${FLOW_MACHINE_ID}.${POLICIES}.${POLICIES_LIST}`,
        },
      },
      [POLICY_MILEAGE]: {
        on: {
          [Events.BACK]: POLICIES_LIST,
          [Events.DONE]: POLICIES_LIST,
        },
      },
      [POLICIES_PAYMENT_ERROR]: {
        on: {
          [Events.BACK]: POLICIES_LIST,
        },
      },
    },
  },
  [LANDING_PAGE]: {
    initial: LANDING_PAGE_ABOUT,
    states: {
      [LANDING_PAGE_ABOUT]: {
        on: {
          [Events.BACK]: [
            {
              target: `#${FLOW_MACHINE_ID}.${POLICIES}.${POLICY_REVIEW}`,
              guard: ({ context }) =>
                has(context.backPath, POLICIES) && get(context.backPath, POLICIES) == POLICY_REVIEW,
            },
            {
              target: `#${FLOW_MACHINE_ID}.${POLICIES}.${POLICY_VERIFY}`,
              guard: ({ context }) =>
                has(context.backPath, POLICIES) && get(context.backPath, POLICIES) == POLICY_VERIFY,
            },
            {
              target: `#${FLOW_MACHINE_ID}.${POLICIES}.${POLICY_CHANGE}`,
              guard: ({ context }) =>
                has(context.backPath, POLICIES) &&
                get(context.backPath, POLICIES) === POLICY_CHANGE,
            },
          ],
        },
      },
      [LANDING_PAGE_QUESTIONS_AND_ANSWERS]: {
        on: {
          [Events.LANDING_PAGE_ABOUT]: LANDING_PAGE_ABOUT,
          [Events.AUTH]: `#${FLOW_MACHINE_ID}.${AUTH}`,
          [Events.BACK]: LANDING_PAGE_ABOUT,
        },
      },
    },
  },
  [ERROR]: {
    on: {
      [Events.BACK]: [
        {
          target: `#${FLOW_MACHINE_ID}.${AUTH_BANK_ID}`,
          guard: ({ context }) =>
            has(context.backPath, POLICIES) && get(context.backPath, POLICIES) === POLICIES_LIST,
        },
        {
          target: `#${FLOW_MACHINE_ID}.${POLICIES}.${POLICY_REVIEW}`,
          guard: ({ event }) => event.backState === POLICY_REVIEW,
        },
        {
          target: `#${FLOW_MACHINE_ID}.${POLICIES}.${POLICIES_LIST}`,
          guard: ({ context }) =>
            has(context.backPath, POLICIES) && get(context.backPath, POLICIES) === POLICY_REVIEW,
        },
        {
          target: `#${FLOW_MACHINE_ID}.${POLICIES}.${POLICY_CHANGE}`,
          guard: ({ context }) =>
            has(context.backPath, POLICIES) && get(context.backPath, POLICIES) === POLICY_CHANGE,
        },
        {
          target: `#${FLOW_MACHINE_ID}.${POLICIES}.${POLICY_VERIFY}`,
          guard: ({ context }) =>
            has(context.backPath, POLICIES) && get(context.backPath, POLICIES) === POLICY_VERIFY,
        },
      ],
    },
  },
})
